<template>
  <transition name="operation-panel">
    <div v-if="doOperationsDisplay() && (!showOptions || !isMobile)" class="operations-container">
      <section
        v-if="(!showOptions || !isMobile)"
        class="operation-panel"
      >
        <operations-navbar
          @toggleShowEvents="$router.push('/events')"
          @toggleOptionsPanel="$emit('toggleOptionsPanel')"
          :is-mobile="isMobile"
          :operation="operation"
          :event="event"
        />
        <transaction-panel
          v-if="operation === 'transactions'"
          :is-mobile="isMobile"
          :user="user"
          :transactions="eventTransactions | toArray"
          :event="event"
          :event-currency="eventCurrency"
          :key="event.id"
        />
        <my-share-panel
          v-if="operation === 'my-share'"
          :user="user"
          :expenses="eventExpenses"
          :event-contacts="event.contacts"
          :event-currency="eventCurrency"
        />
        <debt-panel v-if="operation === 'debts'"/>
        <proposed-transactions
          v-if="operation === 'transactions'
              || operation === 'my-share'"
        />
<!--        <add-event-button-->
<!--          v-if="isMobile"-->
<!--          width="54px"-->
<!--          height="54px"-->
<!--          class="add-event-button"-->
<!--          @click="openEventCreationForm"-->
<!--        />-->
      </section>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex';
import {
  SET_FINAL_USER_SELECTED_CONTACTS,
  SET_USER_SELECTED_CONTACTS,
} from '@/store/user/types';
import OperationsNavbar from '../../components/OperationsNavbar/OperationsNavbar';
import ProposedTransactions from '../../components/ProposedTransactions/ProposedTransactions';
import TransactionPanel from '../../components/TransactionPanel/TransactionPanel';
import MySharePanel from '../../components/MySharePanel/MySharePanel';
import DebtPanel from '../../components/DebtPanel/DebtPanel';
// import AddEventButton from '../../components/AddButtonSmall/AddButtonSmall';

export default {
  name: 'OperationPanel',
  components: {
    // AddEventButton,
    OperationsNavbar,
    ProposedTransactions,
    TransactionPanel,
    DebtPanel,
    MySharePanel,
  },
  props: {
    operation: {
      type: String,
      default: 'transactions',
      validate: (value) => ['transactions', 'my-share', 'debts'].includes(value),
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    showOptions: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user,
      eventTransactions: (state) => state.events.eventTransactions,
      transaction: (state) => state.operations.selectedOperation,
      event: (state) => state.events.event,
      eventCurrency: (state) => state.events.eventCurrency
        || state.user.user.currency,
      eventExpenses: (state) => state.events.eventExpenses,
      currencies: (state) => state.currency.currencies,
    }),
  },
  filters: {
    toArray(array) {
      if (!Array.isArray(array)) {
        return [];
      }
      return array;
    },
  },
  methods: {
    updateOperation(event) {
      this.operation = event;
    },
    doOperationsDisplay() {
      return (this.isMobile && (this.$route.fullPath
        .match(/\/events\/\d+(\/transactions|debts|my-share)?/))
        && (this.$route.fullPath !== '/events')) || !this.isMobile;
    },
    openEventCreationForm() {
      const user = { ...this.$store.state.user.user };
      user.full_name = this.$t('CP.me');
      user.uid = user.user;
      this.$store.commit(SET_USER_SELECTED_CONTACTS, [user]);
      this.$store.commit(SET_FINAL_USER_SELECTED_CONTACTS, [user]);
      this.$bvModal.show('add-event');
    },
  },
};
</script>

<style lang="scss" scoped>
.operations-container {
  flex: 1 0 450px;
  min-height: 100%;
  height: 100%;
}
.operation-panel {
  box-sizing: border-box;
  background-color: #FFFFFF;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  height: 100%;
  border-right: 1px solid #E6ECF8;
}

.noneDisplay {
  display: none;
}

@media screen and (max-width: $breakpoint-sm) {
  .add-event-button {
    position: fixed;
    display: block;
    bottom: 7%;
    right: 7%;
  }
  //animation classes
  .operation-panel-leave-active {
    content: "";
    position: fixed;
    top: 45px;
    bottom: 0;
    right: 0;
    left: 0;
    transition: width .3s linear;
  }

  .operations-container {
    flex: 1 0 375px;
  }

  /*.operation-panel-enter-active {
    position: fixed;
    width: 100%;
    transition: all .3s linear;
  }
  .operation-panel-enter, .operation-panel-leave-to {
    position: fixed;
    width: 100%;
    transform: translateX(-100%);
  }*/
}
</style>
